/**
 * Auth header for API calls. Prefer sending the token in Authorization header
 * instead of query/body to avoid logging and leaking tokens in URLs.
 * @param {string} accessToken - JWT access token
 * @returns {{ Authorization: string }}
 */
export function authHeaders(accessToken) {
  return {
    Authorization: `Bearer ${accessToken}`
  };
}
